import { useEffect } from "react";

const SHARE_URL = "https://cloud.umami.is/share/1iiRkoseiyB2IDCu";

export default function Stats() {
  useEffect(() => {
    // Visiting /stats means it's me: stop counting my visits on this device.
    try { localStorage.setItem("umami.disabled", "1"); } catch (e) {}
    window.location.replace(SHARE_URL);
  }, []);
  return null;
}